import React from 'react';
import { m } from 'framer-motion';
export function ProblemAgitation() {
  return <section className="bg-bg-primary pb-10 sm:pb-14" data-id="element-192" data-mp="1sxu92vws4mca">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-193" data-mp="1szdpqnmckzel">
        <m.h2 initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="font-heading text-2xl font-bold leading-snug text-ink sm:text-3xl" data-id="element-194" data-mp="27ni9lux4zgyy">
          ¿Harto de que el taller se llene de madera sobrante y de clientes que regatean presupuestos de
          reformas pesadas?
        </m.h2>

        <m.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.08
      }} className="mt-5 space-y-4 text-left text-base leading-relaxed text-muted sm:text-center sm:text-lg" data-id="element-195" data-mp="2qksxykh8cpzm">
          <p data-id="element-196" data-mp="rabbd6ie7qmz">Deja de quemar tus retales o de tener las herramientas acumulando polvo en el trastero.</p>
          <p data-id="element-197" data-mp="fmx3ytxfvvz6">
            Con el <span className="font-semibold text-ink" data-id="element-198" data-mp="ko4civ7eoz6w">Kit del Taller Rentable</span>, tendrás los
            planos exactos, las medidas en milímetros y la estrategia de venta para fabricar piezas de alto
            margen usando solo tus herramientas de casa (taladro, caladora y lijadora).
          </p>
          <p className="font-semibold text-brown" data-id="element-199" data-mp="yfrhdjfezg1a">
            Fabrica en 40 minutos. Vende en 24 horas. Recupera la rentabilidad de tu habilidad manual.
          </p>
        </m.div>

        <m.p initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.16
      }} className="mx-auto mt-6 max-w-sm text-sm font-medium italic text-brown" data-id="element-200" data-mp="18dp6e953lguy">
          Diseñado para aprovechar hasta el último trozo de Roble, Haya o Pino que tienes cogiendo polvo en
          la esquina.
        </m.p>
      </div>
    </section>;
}